<template>
  <div class="pt-6 divide-y divide-gray-200">
    <div class="px-4 sm:px-6">
      <div>
        <h2 class="text-lg leading-6 font-medium text-gray-900">
          Password
        </h2>
        <p class="mt-1 text-sm text-gray-500">
          Ensure your account is using a long, random password to stay secure.
        </p>
      </div>
      <div class="mt-4 space-y-4">
        <div
          class="mt-4 mb-6 py-4 px-4 border rounded"
          :class="{
            'border-blue-600 text-blue-700': !messages.error,
            'border-red-600 text-red-700': messages.error
          }"
          v-if="messages !== null"
        >
          <div v-if="messages.error == false">
            {{ messages.messageText }}
          </div>
          <div v-if="messages.error == true">
            {{ messages.messageText }}
          </div>
        </div>

        <div class="block space-y-2" data-children-count="1">
          <label
            for="oldPassword"
            class="block text-sm font-medium text-gray-700"
            >Old Password
          </label>
          <input
            type="password"
            name="oldPassword"
            v-model="oldPassword"
            class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
            required
          />
        </div>

        <div class="block space-y-2" data-children-count="1">
          <label
            for="newPassword"
            class="block text-sm font-medium text-gray-700"
            >New Password
          </label>
          <input
            type="password"
            name="newPassword"
            v-model="newPassword"
            class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
            required
          />
        </div>

        <div class="block space-y-2" data-children-count="1">
          <label
            for="newPasswordRe"
            class="block text-sm font-medium text-gray-700"
            >New Password (Confirm)
          </label>
          <input
            type="password"
            name="newPasswordRe"
            v-model="newPasswordRe"
            class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
            required
          />
        </div>
      </div>
    </div>
    <div class="mt-4 py-4 px-4 flex justify-end sm:px-6">
      <button
        type="submit"
        class="ml-5 bg-light-blue-700 border border-transparent rounded-md shadow-sm py-2 px-4 inline-flex justify-center text-sm font-medium text-white hover:bg-light-blue-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-light-blue-500"
        @click="resetPassword"
      >
        Reset Password
      </button>
    </div>
  </div>
</template>

<script>
import * as Config from "@/config";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "StringerSettingsPassword",
  data() {
    return {
      updatingPassword: false,
      oldPassword: null,
      newPassword: null,
      newPasswordRe: null,
      messages: null
    };
  },
  computed: {
    ...mapGetters(["userInfo"])
  },
  methods: {
    ...mapActions(["addToastMessage"]),
    async resetPassword() {
      this.updatingPassword = true;
      const res = await this.$http.post(
        Config.apiPath + "/api/v2/stringer/account/password",
        {
          old_password: this.oldPassword,
          password: this.newPassword,
          repassword: this.newPasswordRe
        }
      );
      this.messages = res.data;
      this.updatingPassword = false;

      if (!res.data.error)
        return this.addToastMessage({
          type: "success",
          title: "Password Updated"
        });

      this.addToastMessage({
        type: "error",
        title: "Whoops!",
        text:
          "There has been an issue updating your password, please try again."
      });
    }
  }
};
</script>
